import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IUser } from 'src/app/interface/user';
import { environment } from 'src/environments/environment';
import { IResponse } from 'src/app/interface/response';
import { IPaginated } from 'src/app/interface/paginated';

@Injectable({
	providedIn: 'root',
})
export class ShiftService {

	constructor(private httpClient: HttpClient) { }

	public store(data?: IStore): Observable<ICrewResponse> {
		return this.httpClient.post<ICrewResponse>(
			environment.apiUrl + '/{current_company_id}/shift/store',
			data
		);
	}

	public myCrew(): Observable<ICrewResponse> {
		return this.httpClient.get<ICrewResponse>(
			environment.apiUrl + '/{current_company_id}/shift/my_crew'
		);
	}

	public companyShifts(
		page?: number,
		search?: string
	): Observable<IPaginated<IUser>> {
		let httpParams = new HttpParams();
		if (page) {
			httpParams = httpParams.append('page', page?.toString());
		}
		if (search) {
			httpParams = httpParams.append('search', search?.toString());
		}
		return this.httpClient.get<IPaginated<IUser>>(
			environment.apiUrl + '/{current_company_id}/shift/company_shifts',
			{ params: httpParams }
		);
	}

	public requestBringIn(operatorId: number): Observable<IResponse> {
		return this.httpClient.post<IResponse>(
			environment.apiUrl + '/{current_company_id}/shift/request_bring_in',
			{ operator_id: operatorId }
		);
	}

	public answerBringIn(messageId: number, answer: boolean, shiftId: number): Observable<IResponse> {
		return this.httpClient.post<IResponse>(
			environment.apiUrl + '/{current_company_id}/shift/answer_bring_in',
			{
				message_id: messageId,
				answer,
				shift_id: shiftId
			}
		);
	}

}

interface ICrewResponse extends IResponse {
	crew?: Array<IUser>;
}

interface IStore {
	notes?: string;
	operators?: Array<IUser>;
  forced?:Array<string>;
}
